/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2018 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import { PageNumberUI } from "components/hud/PageNumberUI";
import { providers } from "dc-core";
import { getTotalPages, shouldStartRendering, getFileExtension } from "selectors/documentSelectors";
import { getCurrentPageNumber } from "selectors/pageNumber";
import { getShouldUseModernViewer } from "selectors/appSelectors";
import { handleKeyPressOnPageNumberUI, handleKeyDownOnPageNumberUI } from "services/NavigationBarService";
import { inject } from "mobx-react";
import { TOOLTIP_DELAY, KEYBOARD_SHORTCUTS } from "constants/constants";
import { withKeyboardShortcutLabel } from "components/hocs/withKeyboardShortcutLabel";

const mapStoreToProps = stores => {
  const useModernViewer = getShouldUseModernViewer(stores);
  const props = {
    totalPages: getTotalPages(stores),
    currentPage: getCurrentPageNumber(stores),
    useModernViewer: getShouldUseModernViewer(stores),
    handleKeyPress: handleKeyPressOnPageNumberUI,
    handleKeyDown: handleKeyDownOnPageNumberUI,
    inputAriaLabel: useModernViewer ? "modernviewer.arialabel.goToPage" : "arialabel.goToPage",
    inputTooltipString: useModernViewer ? "modernviewer.tooltip.goToPage" : "tooltip.goToPage",
    totalPagesTooltip: "modernviewer.tooltip.totalPages",
    tooltipDelay: TOOLTIP_DELAY,
    fileExtension: getFileExtension(stores).toUpperCase(),
    shouldStartRendering: shouldStartRendering(stores),
    setPageNumberInputHandle: handle => stores.pagedViewState.setPageNumberInputHandle(handle)
  };
  return props;
};

const PageNumberUIContainer = inject(mapStoreToProps)(
  withKeyboardShortcutLabel(KEYBOARD_SHORTCUTS.GOTO_PAGE, PageNumberUI)
);

export { PageNumberUIContainer };
